/**
 * Created by qingzhui on 16/12/31.
 */
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
// require('../../scss/utils/bootstrap/bootstrap.min.css');
require('../../scss/utils/bootstrap/bootstrap.min.css');

require('animate.css/animate.min.css');

require('../../scss/m/m-irfinance.scss');

var common = require('./m-common');
var minioUrl = common.minioUrl;
var $ = require('jquery');

var lang=''
var objResult={}
$( document ).ready(function() {

    var langInput = document.getElementById('lang');
    lang = langInput ? langInput.value : undefined;
    
    
    $(window).scroll(function () {
             //检测滚走的高度
        var scrollT = $(document).scrollTop();
             //当滚走的高度>=400(天蓝色色块的上边距)，
             //显示返回顶部(.back)，否则隐藏返回顶部
             //获取蓝色色块(container)距离文档顶部的距离
        var offsetT = $('body').offset().top;
             //进行判断
        console.log('aaa',scrollT,offsetT);
        if (scrollT >offsetT) {
            $('.scoll').show()
        } else {
            $('.scoll').hide()
        }
    })
         
         //点击返回顶部，页面滚走的距离设置为0
    $('.scoll').click(function(){
             //生硬的返回
             // $(document).scrollTop(0)
             //动感的返回
             //animate({键:值},时间) 属性：scrollTop---必须是被元素调用
        $('html,body').animate({
            scrollTop:0
        },1000)
    })


    // if(lang == 'en'){
    //     $('#CUNav').addClass('f-fHNLTP63ME');
    // }else{
    //     $('#CUNav').addClass('f-fZHBold');
    //     $('.tit').addClass('f-fZHBold');
    // }
    // var data = mockData.getData();
    // console.log(data)
    getData(getDatas)
    $('#ir').addClass('active');
    var $root = $('html, body');
    $('.navta').click(function() {

        var href = $.attr(this, 'href');
        var navt = $(this).parent('.navt');
        var prevActive = navt.parents('.nav-two').find('.active');

        prevActive.removeClass('active');

		//now selected nav
        navt.addClass('active');
        $root.animate({
            scrollTop: $(href).offset().top
        }, 1000, function() {
            window.location.hash = href;
        });
        return false;
    });
    var CLWidth = $('.course-line').width();
    var leftBoxWidth = CLWidth / 2;
    $('.course-line .left-box').width(leftBoxWidth);
    function getDatas(objResult) {
        console.log('aaa',objResult);
    }
});




var dataArray = [];

function getData(getDatas) {
    var api = common.baseUrl();
	//  var ajaxUrl = api + 'v1/member';
    var ajaxUrl = api + 'v1/ir/finance';
	//	console.log(ajaxUrl)
    $.ajax({
        url: ajaxUrl,
        type: 'get',
        dataType: 'json',
		//      dataType: 'text',
        data: {
            lang: lang
        },
        success: function(data) {
			
            if(data.status) {
                objResult=data.result
                getDatas(objResult)
                // var jsonData = mockData.getData();
                var result = data.result;
				// data.result.push(datas.result[0])
                var str = '';
                // 财务摘要 financialSummary
                var financialSummary = result.financialSummary;
                // var arr = financialSummary.map(function(item, index){
                //     return '<img src=' + item.img + ' class="w-p100">'
                // });

                // 财务报告 financialReport
                var financialReport = result.financialReport;
                var tabStr = '', tabStrStart = '<ul id="myTab" class="nav nav-tabs">', tabStrEnd = '</ul>';
                var tabContentStr = '', tabContentStrStart = '<div id="myTabContent" class="tab-content">', tabContentStrEnd = '</div>';
                var tabStrArr = financialReport.map(function(item, index){
                    var startStr = index === 0 ? '<li class="active">' : '<li>';
                    var str =  startStr + '<a href="#' + item.title.replace(/\s+/g,'_') + '" data-toggle="tab">' + item.title + '</a></li>';
                    return str;
                });
                var tabContentStrArr = financialReport.map(function(item, index){
                    var startStr = index === 0 ? ' <div class="tab-pane fade in active"' : '<div class="tab-pane fade"';
                    startStr += ' id="' + item.title.replace(/\s+/g,'_') + '">';
                    var endStr = '</div>';
                    var tableStr = '', tableStartStr = '<table class="table"><tbody>', tableEndStr = '</tbody></table>';
                    var tableArr = item.list.map(function(ite, jndex){
                        var tdStartStr = '<tr><td class="text-left"><a target="_blank" href="';
                        tdStartStr +=  ((ite.link&&ite.link.length>0)? `${ minioUrl + ite.link[0].docPath}`: '') + '" title="' + ite.title + '">' +
                            '<div class="col-md-4" style="height:100%; width:100%">' +
                                '<img height="590" style="width:100%;height:auto;" class="attachment-post-thumbnail size-post-thumbnail wp-post-image" src="' + minioUrl + ite.thumbnail + '">' +
                            '</div></a>' + 
                            '<div reports-description">' +
                                '<p class="titlename">' + ite.title + '</p>' +
                            '</div>' +
                        '</td></tr>';
                        return tdStartStr;
                    });
                    tableStr = tableStartStr + tableArr.join('') + tableEndStr
                    
                    var str =  startStr + tableStr + endStr ;
                    return str;
                });
                tabStr += (tabStrStart + tabStrArr.join('') + tabStrEnd);
                tabContentStr += (tabContentStrStart + tabContentStrArr.join('') + tabContentStrEnd);

                /**
                 * 通函及公告
                 */

                var announcements = result.announcements;
                var announcementsTabStr = '', announcementsTabStrStart = '<ul class="nav nav-tabs">', announcementsTabStrEnd = '</ul>';
                var announcementsStr = '', announcementsStrStart = '<div id="myTabContent" class="tab-content">', announcementsStrEnd = '</div>';
                var announcementsTabStrArr = announcements.map(function(item, index){
                    var startStr = index === 0 ? '<li class="active">' : '<li>';
                    var str =  startStr + '<a href="#' + item.year + '" data-toggle="tab">' + item.year + '</a></li>';
                    return str;
                });

                var announcementsStrArr = announcements.map(function(item, index){
                    var startStr = index === 0 ? ' <div class="tab-pane fade in active"' : '<div class="tab-pane fade"';
                    startStr += ' id="' + item.year + '">';
                    var endStr = '</div>';
                    var tableStr = '', tableStartStr = '<table class="table"><tbody>', tableEndStr = '</tbody></table>';
                    var tableArr = item.list.map(function(ite, jndex){
                        // var tdStartStr = '<tr class="col-md-6"><td class="text-left"><a target="_blank" href="';
                        // tdStartStr +=  ite.link + '" title="' + ite.title + '">' +
                        //     '<div class="col-md-4">' +
                        //         '<img width="173" class="attachment-post-thumbnail size-post-thumbnail wp-post-image" src="' + ite.thumbnail + '">' +
                        //     '</div></a>' + 
                        //     '<div class="col-md-8 reports-description">' +
                        //         '<p class="titlename">' + ite.title + '</p>' +
                        //     '</div>' +
                        // '</td></tr>';
                        // return tdStartStr;

                        return  '<tr>' +
                                    '<td class="text-left">' +
                                        '<p class="filedate">' + ite.time + '</p>' +
                                        '<p class="titlename">' + ite.title + '</p>' +
                                        '<p class="fileinfo">' + 
                                            '<a class="file-a" target="_blank" href="' + minioUrl + ite.link + '" title="' + ite.content + '">' +ite.content +'('+ (ite.filetype?ite.filetype.toUpperCase():'')+','+ite.filesize+')'+ '</a>' +
                                        '</p>' + 
                                    '</td>' +
                                '</tr>';

                    });
                    tableStr = tableStartStr + tableArr.join('') + tableEndStr
                    
                    var str =  startStr + tableStr + endStr ;
                    return str;
                });
                announcementsTabStr += (announcementsTabStrStart + announcementsTabStrArr.join('') + announcementsTabStrEnd);
                announcementsStr += (announcementsStrStart + announcementsStrArr.join('') + announcementsStrEnd);
                console.log('aaa',financialSummary);
                //  财务摘要
                $('#financial-summary-content').html(financialSummary);
                // 财务报告
                $('#financial-report-content').html(tabStr + tabContentStr);
				// 通函及公告
                $('#announcements-content').html(announcementsTabStr + announcementsStr);

            }
        },
        error: function(msg) {
            console.log(msg);
        }

    })
}



// WEBPACK FOOTER //
// ./src/m/m-irfinance.js